import './gioithieu.scss'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

function GioiThieuLayout({ userdata, referralLink, datanguoi }) {
  const handleCopy = text => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success(' คัดลอกสำเร็จ', {
          position: 'top-right',
          autoClose: 3000
        })
      })
      .catch(() => {
        toast.error('คัดลอกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง!')
      })
  }

  return (
    <div className='divtongquan_container'>
      <ToastContainer position='top-right' autoClose={3000} />
      <div className='tongquan_header'>
        <div className='tongquan_title'>
          <img src='/account/hoahong/hoahonggt.png' alt='' width={24} height={24} />
          <div>แนะนำ</div>
        </div>
        <div className='tongquan_descreption'>
            หมายเหตุ: ผู้ได้รับเชิญแต่ละคนสามารถสมัครผ่านช่องทางการแนะนำได้เพียงช่องทางเดียวเท่านั้น
        </div>
      </div>
      <div className='gioithieu_body'>
        <div className='header_gioithieu'>
          {/* icon */}
          <span>ลิงก์แนะนำ</span>
        </div>
        <div className='formgioithieu'>
          <label>รหัสแนะนำ</label>
          <div className='formgioithieu_input'>
            <input type='text' value={userdata?.code || ''} readOnly />
            <span onClick={() => handleCopy(userdata?.code || '')}>คัดลอก</span>
          </div>
        </div>
        <div className='formgioithieu'>
          <label>ลิงก์แนะนำ</label>
          <div className='formgioithieu_input'>
            <input type='text' value={referralLink} readOnly />
            <span onClick={() => handleCopy(referralLink)}>คัดลอก</span>
          </div>
        </div>

      </div>
    </div>
  )
}


export default GioiThieuLayout
